import * as React from "react";

const SvgIcnSmsBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M8.667 4h6.666C16.253 4 17 4.716 17 5.6v12.8c0 .884-.746 1.6-1.667 1.6H8.667C7.747 20 7 19.284 7 18.4V5.6C7 4.716 7.746 4 8.667 4zm2.066 1.6a.4.4 0 100 .8h2.534a.4.4 0 100-.8h-2.534zm1.234 11.2a.8.8 0 100 1.6h.066a.8.8 0 100-1.6h-.066z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnSmsBold;
